import {
  Component,
  ElementRef,
  Input,
  ModelOptions,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { Dialog, DialogType } from '../../shared.model';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrl: './dialog.component.css',
    standalone: false
})
export class DialogComponent implements OnInit {
  @ViewChild('template') templateRef?: TemplateRef<void>;
  public dialogTypeEnum = DialogType;
  modalRef?: NgbModalRef;
  dialogData?: Dialog | null;
  actionButtonText?: string;
  clickEvent?: () => void;
  config : NgbModalOptions = {
    animation: true,
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  showClose : boolean = true;
  constructor(
    private dialogService: DialogService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.dialogService.dialog$.subscribe((res) => {
      if (res.type == 'show') {
        const data = res.data as Dialog;
        this.dialogData = {
          ...this.dialogData,
          ...data
        };
        if(data?.close){
          this.showClose = data.close;
        }
        this.updateDetails();
        const config = {
          ...this.config,
          size: data.size ?? 'lg',
        };
        this.modalRef = this.modalService.open(this.templateRef!, config);
        if (!this.dialogData.onClick) {
          this.clickEvent = this.hideDialog;
        } else {
          this.clickEvent = this.dialogData.onClick;
        }
      } else {
        this.dialogData = null;
        this.modalRef?.close();
      }
    });
  }

  private updateDetails() {
    switch (this.dialogData?.dialogType) {
      case DialogType.Alert:
        this.actionButtonText = 'OK';
        break;
      case DialogType.Confirm:
        this.actionButtonText = 'Confirm';
        break;
    }
  }

  hideDialog() {
    this.modalRef?.close();
  }
}
